/**
 *  <Desription of Service here>
 *
 * @export
 * @class DataManager
 */
export class DataManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$q', '$http', 'DevTools', '$location'];
  public static CONFIG_FILE_NAME: string = 'config.json'
  public config: any = undefined;
  public langContent: any = undefined;
  public configUrl: string
  public path
  public configFileUrl
  public localizationFileUrl

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public $q: any, public $http: any, public DevTools: any, public $location: any) {
    this.$log = $log.getInstance('DataManager', false);
    this.$log.debug('constructor');

    /*if (this.DevTools.isDevelopmentEnvironment()) {
      this.configUrl = DataManager.CONFIG_FILE_NAME
    } else {*/
    this.path = $location.absUrl();
    this.configFileUrl = this.path.replace("index.html", "");
    this.localizationFileUrl = this.path.replace("index.html", "");
    let position = this.configFileUrl.indexOf('?');
    if (position !== -1) {
      this.configUrl = this.configFileUrl.substr(0, position) + DataManager.CONFIG_FILE_NAME;
      this.localizationFileUrl = this.configFileUrl.substr(0, position)
    } else {
      this.configUrl = this.configFileUrl + DataManager.CONFIG_FILE_NAME
    }
    // this.configUrl = DataManager.MARVEL_CDN_PATH + DataManager.CONFIG_FILE_NAME
    // this.configUrl = DataManager.MARVEL_INTL_PATH + DataManager.CONFIG_FILE_NAME
    //}
  }

  public load() {
    let deferred = this.$q.defer();
    this.$http.get(this.configUrl).then(response => {
      this.$log.debug('load', response.data)
      this.config = response.data
      deferred.resolve(response.data);
    }, response => {
      deferred.reject(response);
    })
    return deferred.promise;
  }

  public loadLanguage() {
    //console.log(this.localizationFileUrl)
    this.$http.get(this.localizationFileUrl + 'media/strings/strings.json').then((response) => {
      this.langContent = response.data
    });
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/data-manager/data-manager.ts
 **/